module.exports = __webpack_public_path__ + "static/media/my-courses.3ef628f8.svg";